import { useState } from 'react';
import { ChatSessionListItem, Document, Project } from '../../../services/api';

export function useChatContext() {
  const [contextMode, setContextMode] = useState<'auto' | 'all' | 'selected'>('auto');
  const [selectedDocs, setSelectedDocs] = useState<Document[]>([]);
  const [selectedChats, setSelectedChats] = useState<ChatSessionListItem[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<Project[]>([]);
  const [attachedFiles, setAttachedFiles] = useState<File[]>([]);
  const [contextLocked, setContextLocked] = useState(false);
  const [uploadStatusLines, setUploadStatusLines] = useState<string[]>([]);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    const totalCount = selectedDocs.length + selectedChats.length + selectedProjects.length + attachedFiles.length;
    const availableSlots = 3 - totalCount;
    if (availableSlots > 0) {
      setAttachedFiles((prev) => [...prev, ...files.slice(0, availableSlots)]);
    }
  };

  const removeAttachedFile = (index: number) => {
    setAttachedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const removeSelectedDoc = (docId: string) =>
    setSelectedDocs((prev) => prev.filter((d) => d.id !== docId));

  const removeSelectedChat = (chatId: string) =>
    setSelectedChats((prev) => prev.filter((c) => c.id !== chatId));

  const removeSelectedProject = (projectId: string) =>
    setSelectedProjects((prev) => prev.filter((p) => p.id !== projectId));

  return {
    contextMode,
    setContextMode,
    selectedDocs,
    setSelectedDocs,
    selectedChats,
    setSelectedChats,
    selectedProjects,
    setSelectedProjects,
    attachedFiles,
    setAttachedFiles,
    contextLocked,
    setContextLocked,
    uploadStatusLines,
    setUploadStatusLines,
    handleFileSelect,
    removeAttachedFile,
    removeSelectedDoc,
    removeSelectedChat,
    removeSelectedProject,
  };
}
